import { render } from "./CheckUpdatesPage.vue?vue&type=template&id=03abd05c&scoped=true"
import script from "./CheckUpdatesPage.vue?vue&type=script&lang=js"
export * from "./CheckUpdatesPage.vue?vue&type=script&lang=js"

import "./CheckUpdatesPage.vue?vue&type=style&index=0&id=03abd05c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03abd05c"]])

export default __exports__